import React from "react";
import { withRouter } from 'react-router-dom';
import { Layout, message, Modal } from "antd";
import posed from "react-pose";
import styles from "./master.module.css";
import "./master.css";
import "../../files/common.css";
import { loginAuth, fetchAuth, refreshTokenCycle, gotoWorkSite } from "../../util/auth.js";
import WaitBlock from '../../util/waitblock';

import Header from "./header/header.js";
import Content from "./content/content.js";
import Footer from "./footer/footer.js";
import RMMenu from "../../menu/menu.js";

import mainBG from "../../files/images/backgrounds/1_main.png";
import loginBG from "../../files/images/backgrounds/2_login.png";
import solutionsBG from "../../files/images/backgrounds/3_solutions.png";
import descriptionBG from "../../files/images/backgrounds/4_description.png";
import connectionBG from "../../files/images/backgrounds/6_connection.png";
import tariffsBG from "../../files/images/backgrounds/8_tariffs.png";
import articlesBG from "../../files/images/backgrounds/9_articles.png";
import feedbackBG from "../../files/images/backgrounds/10_feedback.png";
import licensesBG from "../../files/images/backgrounds/11_licenses.png";
import partnersBG from "../../files/images/backgrounds/12_partners.png";
import contactsBG from "../../files/images/backgrounds/14_contacts.png";

const Master = withRouter(props => <MasterComponent {...props} />);

const MainSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const LoginSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const SolutionsSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const DescriptionSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const HeatmetersSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const ConnectionSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const NewsSlide = posed.div({
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
});
const TariffsSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const ArticlesSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const FeedbackSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const LicensesSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const PartnersSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});
const ContactsSlide = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
});

class MasterComponent extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
          isLoading: false,
          modalVisible: false,
          modalImage: null,
      //isDisplayLoader: false,
      loaderText: "",
      isLogged: false,
      userName: null,
      isActiveHeader: false,
      isMainVisible: true,
      isLoginVisible: false,
      isMenuExtended: true,
      carouselCurrentSlide: 0,
        menuItemIndex: "/"
    };

    //this.startAnimating = this.startAnimating.bind(this);
    //this.stopAnimating = this.stopAnimating.bind(this);
      this.showModal = this.showModal.bind(this);
    this.exit = this.exit.bind(this);
    this.demoEnter = this.demoEnter.bind(this);
    this.setUser = this.setUser.bind(this);
    this.login = this.login.bind(this);
      this.demoEnter = this.demoEnter.bind(this);
    this.recoverPassword = this.recoverPassword.bind(this);
    this.menuShrinkHandler = this.menuShrinkHandler.bind(this);
    this.carouselCurrentSlideHandler = this.carouselCurrentSlideHandler.bind(this);
      this.menuItemHandler = this.menuItemHandler.bind(this);
      this.refreshToken = this.refreshToken.bind(this);
      this._cycletimer = null;
      this._timer = null;
      this._subscription = null;
  }

    componentDidMount() {
        if (this.props.history.action === "POP") {
                if (this.state.isLoading) {
                    this.setState({ isLoading: false });
                }
        }
        this.refreshToken();
    }

    componentWillUnmount() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        if (this._cycletimer) {
            clearInterval(this._cycletimer);
            this._cycletimer = null;
        }
        if (this._subscription) {
            this._subscription.remove();
        }
    };

    refreshToken() {
        refreshTokenCycle(
            window.configTI.URL_BACKEND + '/profile/refresh',
            (user, lifeMinutes) => {
                if (this._cycletimer) {
                    clearInterval(this._cycletimer);
                    this._cycletimer = null;
                }
                if (!this.state.isLogged) {
                    this.setUser(user, true);
                }
                if (lifeMinutes) {
                    this._timer = setTimeout(this.refreshToken, lifeMinutes*60000);
                }
            },
            () => {
                if (this.state.isLogged) {
                    this.setUser('', false);
                }
                if (this._cycletimer == null) {
                    this._cycletimer = setInterval(this.refreshToken, 1000);
                }
            });
    }

    exit = async () => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        fetchAuth(window.configTI.URL_BACKEND + '/profile/exit', requestOptions)
            .then(data => {
                if (data.bodyStatus && (data.bodyStatus === 1 || data.bodyStatus === 4)) {
                    this.setUser(null, false);
                    message.success("Выход выполнен");
                }
                else if (data.bodyStatus && data.bodyStatus === 3) {
                    message.error(data.message);
                }
                else {
                    message.error('Ответ не получен.');
                }
            })
            .catch(error => {
                message.error('Ошибка:' + error);
                console.log(error);
            });

    };

    setUser = (user, isLogged) => {
        this.setState({ userName: user, isLogged: isLogged });
  };
    demoEnter = () => {
        var request = {
            User: window.configTI.DEMO_USER,
            Password: window.configTI.DEMO_PASSWORD
        };
        this.login(request);
    }

    //Вход в личный кабинет.
    //inputCredentials: {User: <userName>, Password: <password>}
    login = inputCredentials => {
        this.setState({ isLoading: true });
        loginAuth(window.configTI.URL_BACKEND + '/profile/login', inputCredentials.User, inputCredentials.Password)
            .then(data => {
                if (data.bodyStatus && data.bodyStatus === 1) {
                    const token = data.body.token;
                    if (token) {
                        this.setUser(token.login, true);
                        this.fToWorkSite();
                    }
                    if(data.body.done){
                      message.success('Вход выполнен');
                    }
                    else if(data.body.isLocked){
                      this.setState({ isLoading: false });
                      Modal.warning({
                        className: 'customModal',
                        title: 'Личный кабинет заблокирован',
                        content: (
                          <>
                            <div>
                              <span>Вы неверно ввели пароль 5 раз. Личный Кабинет заблокирован. Для разблокировки обратитесь к администратору. </span>
                              <a href='/contacts'>Контакты</a>
                              </div>
                          </>
                        ),
                      });
                    }
                    else if(data.body.message && data.body.message.length > 0){
                      this.setState({ isLoading: false });
                      message.warning(data.body.message, 10);
                    }
                    else {
                        this.setState({ isLoading: false });
                        message.warning('Системная ошибка при выполнении входа.');
                    }
                }
                else if (data.bodyStatus && (data.bodyStatus === 3 || data.bodyStatus === 2)) {
                    message.warning(data.message);
                    this.setState({ isLoading: false });
                }
                else {
                    message.warning('Системная ошибка при выполнении входа.');
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                message.warning('Сервер недоступен.');
                this.setState({ isLoading: false });
                console.log(error);
            });
    };


  //Восстановление пароля.
  recoverPassword = userName => {
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(userName)
      };
      fetch(window.configTI.URL_BACKEND + '/profile/pswrecover', requestOptions)
          .then(response => response.json())
          .then(data => {
              if (data.bodyStatus && data.bodyStatus === 1) {
                  const result = data.body;
                  if (result) {
                      //!!!!! При таком способе восстановления пароля. Пароль может быть сброшен любым пользователем
                      //для другого пользователя, который получит его на свою почту (и может об этом не узнать).
                      //Нормально отправлять промежуточный код восстановления на почту и по промежуточной ссылке 
                      //сбрасывать пароль.
                      message.success("На Вашу почту отправлен новый пароль.");
                  }
                  else {
                      message.success("Автоматически восстановить пароль не удалось. Для восстановления пароля обратитесь в службу поддержки.");
                  }
              }
              else if (data.bodyStatus && data.bodyStatus === 3) {
				  const messageText = data.message + " Обратитесь в службу поддержки.";
                  message.error(messageText);
              }
              else {
                  message.error('Ответ не получен.');
              }
          })
          .catch(error => {
              message.error('Ошибка:' + error);
              console.log(error);
          });
  };

    menuItemHandler = e => {
        if (e === "/login") {
            if (this.state.isLogged) {
                this.setState({ isLoading: true })
            }
            this.fToWorkSite();
        }

    let currentSlide = "/";

    switch (e) {
      case "/login":
        currentSlide = -1;
        break;
      case "/solutions":
        currentSlide = -2;
        break;
      case "/description":
        currentSlide = -3;
        break;
      case "/hmeters":
        currentSlide = -4;
        break;
      case "/connection":
        currentSlide = -5;
        break;
      case "/news":
        currentSlide = -6;
        break;
      case "/tariffs":
        currentSlide = -7;
        break;
      case "/articles":
        currentSlide = -8;
        break;
      case "/feedback":
        currentSlide = -9;
        break;
      case "/licenses":
        currentSlide = -10;
        break;
      case "/partners":
        currentSlide = -11;
        break;
      case "/tutorial":
        currentSlide = -12;
        break;
      case "/contacts":
        currentSlide = -13;
        break;
      default:
        currentSlide = 0;
    }

    this.setState({
      menuItemIndex: e,
      carouselCurrentSlide: currentSlide
    });
  };

    fToWorkSite = () => {
        if (this.state.isLogged) {
            gotoWorkSite(
                () => { },
                () => {
                    message.warn("Не удалось перейти на рабочий сайт");
                    if (this.props.history.location.pathname !== "/login") {
                        this.props.history.push("/login");
                    }
                }
            )
        }
        else if (this.props.history.location.pathname !== "/login"){
            this.props.history.push("/login");
        }
    }

  menuShrinkHandler = e => {
    this.setState({
      isMenuExtended: !e
    });
  };

  carouselCurrentSlideHandler(currentSlide, slideCount) {
    this.setState({
      carouselCurrentSlide: currentSlide
    });
  }

  bgPositionGet(slideIndex) {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox";

    let xOffset = 0;
    let yOffset = 0;

    switch (slideIndex) {
      case 1:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? -1.5 : -1.5;
        break;
      case 2:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? -1.25 : -1.25;
        break;
      case 3:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? -0.7 : -0.7;
        break;
      case 4:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? -7.78 : -7.78;
        break;
      case 5:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 0 : 0;
        break;
      case 6:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 2.12 : 2.12;
        break;
      case 7:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 0.7 : 0.7;
        break;
      case 8:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 4.38 : 4.38;
        break;
      case 9:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 4.035 : 4.035;
        break;
      case 10:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 0 : 0;
        break;
      case 11:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 0 : 0;
        break;
      case -6:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? -0.7 : -0.7;
        break;
      case -7:
        xOffset = this.state.isMenuExtended ? 18.8 : 8.85;
        yOffset = firefox ? 2.12 : 2.12;
        break;
      default:
        xOffset = this.state.isMenuExtended ? 18.7 : 8.85;
        yOffset = firefox ? -3.3 : -3.3;
    }

    const offset = `${xOffset}em ${yOffset}em`;

    return offset;
  }

    showModal = (image) => {
        this.setState({ modalVisible: true, modalImage: image })
    }
    onModalClose = () => {
        this.setState({ modalVisible: false})
    }

    render() {
    return (
        <React.Fragment>
            { this.state.isLoading && <WaitBlock />}
      <Layout
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "white",
          position: "relative"
        }}
      >


        <MainSlide
                pose={this.state.carouselCurrentSlide === 0 && this.props.location.pathname === "/" ? "visible" : "hidden"}
                demoEnter={this.demoEnter}
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ? "url(" + mainBG + ")" : null,
            backgroundPosition: this.bgPositionGet(0),
            backgroundSize: this.state.isMenuExtended
              ? "70.9em 46.55em"
              : "81em 46.55em"
          }}
        />
        <LoginSlide
          pose={
            this.state.carouselCurrentSlide === 1 ||
              //this.state.carouselCurrentSlide === -1 ||
              this.props.location.pathname === "/login"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/login"
                ? "url(" + loginBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(1),
            backgroundSize: this.state.isMenuExtended
              ? "69.3em 52.5em"
              : "79.5em 52.5em"
          }}
        />

        <SolutionsSlide
          pose={
            this.state.carouselCurrentSlide === 2 ||
              //this.state.carouselCurrentSlide === -2 ||
              this.props.location.pathname === "/solutions"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/solutions"
                ? "url(" + solutionsBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(2),
            backgroundSize: this.state.isMenuExtended
              ? "73.9em 53em"
              : "83.9em 53em"
          }}
        />
        <DescriptionSlide
          pose={
            this.state.carouselCurrentSlide === 3 ||
              //this.state.carouselCurrentSlide === -3 ||
              this.props.location.pathname === "/description"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/description"
                ? "url(" + descriptionBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(3),
            backgroundSize: this.state.isMenuExtended
              ? "73.9em 50.35em"
              : "83.9em 50.35em"
          }}
        />
        <HeatmetersSlide
          pose={
            this.state.carouselCurrentSlide === 4 || 
            //this.state.carouselCurrentSlide === -4 || 
            this.props.location.pathname === "/hmeters"
              ?
              "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/hmeters"
                ? "url(" + tariffsBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(4),
            backgroundSize: this.state.isMenuExtended
              ? "73.85em 53em"
              : "83.9em 53em"
          }}
        />

        <ConnectionSlide
          pose={
            this.state.carouselCurrentSlide === 5 ||
              this.props.location.pathname === "/connection" ||
              this.props.location.pathname === "/zayv_na_uslugi" ||
              this.props.location.pathname === "/zayv_na_obor" ||
              this.props.location.pathname === "/zayv_na_vstr"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/connection"
                ? "url(" + connectionBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(5),
            backgroundSize: this.state.isMenuExtended
              ? "73.8em 53.6em"
              : "83.9em 53.6em"
          }}
        />

                <NewsSlide
                    pose={
                        this.props.location.pathname === "/news"
                            ? "visible"
                            : "hidden"
                    }
                    className={styles.backgroundContainer}
                    style={{
                        backgroundImage:
                            this.state.menuItemIndex === "/" ||
                                this.state.menuItemIndex === "/news"
                                ? "url(" + connectionBG + ")"
                                : null,
                        backgroundPosition: this.bgPositionGet(6),
                        backgroundSize: this.state.isMenuExtended
                            ? "73.8em 55.3em"
                            : "83.9em 55.3em"
                    }}
                />

        <TariffsSlide
          pose={
            this.state.carouselCurrentSlide === 6 ||
              //this.state.carouselCurrentSlide === -6 ||
              this.state.carouselCurrentSlide === -7 ||
              this.props.location.pathname === "/tariffs"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/tariffs" ||
                this.state.menuItemIndex === "/news"
                ? "url(" + tariffsBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(
              this.state.carouselCurrentSlide
            ),
            backgroundSize: this.state.isMenuExtended
              ? "73.85em 50.45em"
              : "83.89em 50.45em"
          }}
        />

        <ArticlesSlide
          pose={
            this.state.carouselCurrentSlide === 7 ||
              //this.state.carouselCurrentSlide === -8 ||
              this.props.location.pathname === "/articles"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/articles"
                ? "url(" + articlesBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(7),
            backgroundSize: this.state.isMenuExtended
              ? "73.85em 53.58em"
              : "83.89em 53.58em"
          }}
        />

        <FeedbackSlide
          pose={
            this.state.carouselCurrentSlide === 8 ||
              //this.state.carouselCurrentSlide === -9 ||
              this.props.location.pathname === "/feedback"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/feedback"
                ? "url(" + feedbackBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(8),
            backgroundSize: this.state.isMenuExtended
              ? "73.85em 54.15em"
              : "83.89em 54.15em"
          }}
        />

        <LicensesSlide
          pose={
            this.state.carouselCurrentSlide === 9 ||
              //this.state.carouselCurrentSlide === -10 ||
              this.props.location.pathname === "/licenses"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/licenses"
                ? "url(" + licensesBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(9),
            backgroundSize: this.state.isMenuExtended
              ? "73.85em 53.6em"
              : "83.89em 53.6em"
          }}
        />

        <PartnersSlide
          pose={
            this.state.carouselCurrentSlide === 10 ||
              //this.state.carouselCurrentSlide === -11 ||
              this.props.location.pathname === "/partners"
              ? //|| this.state.carouselCurrentSlide === -12
              "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/partners" ||
                this.state.menuItemIndex === "/tutorial" ||
                this.props.location.pathname === "/partners"
                ? "url(" + partnersBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(10),
            backgroundSize: this.state.isMenuExtended
              ? "73.85em 60.95em"
              : "83.89em 60.95em"
          }}
        />

        <ContactsSlide
          pose={
            this.state.carouselCurrentSlide === 11 ||
              //this.state.carouselCurrentSlide === -13 ||
              this.props.location.pathname === "/contacts"
              ? "visible"
              : "hidden"
          }
          className={styles.backgroundContainer}
          style={{
            backgroundImage:
              this.state.menuItemIndex === "/" ||
                this.state.menuItemIndex === "/contacts"
                ? "url(" + contactsBG + ")"
                : null,
            backgroundPosition: this.bgPositionGet(11),
            backgroundSize: this.state.isMenuExtended
              ? "73.85em 60.52em"
              : "83.89em 60.52em"
          }}
        />

            <div className={styles.gridLayout}>
                <Header isLogged={this.state.isLogged} user={this.state.userName} isMenuExtended={this.state.isMenuExtended} exit={this.exit }/>
                <RMMenu
                    isLogged={ this.state.isLogged}
                    isCarousel={this.state.carouselCurrentSlide < 0 ? false : true}
                    menuShrinkHandler={this.menuShrinkHandler}
                    currentSlide={this.state.carouselCurrentSlide}
                    menuItemHandler={this.menuItemHandler}
              />
            <Content
                        isLogged={this.state.isLogged}
                        login={this.login}
                        demoEnter={this.demoEnter}
                        recoverPassword={this.recoverPassword}
                        menuExtended={this.state.isMenuExtended}
                        carouselCurrentSlideHandler={this.carouselCurrentSlideHandler}
                        carouselCurrentSlide={this.state.carouselCurrentSlide}
                        showModal={this.showModal}
            />
          <Footer />
        </div>
            </Layout>
            <Modal
                width = "auto"
                visible={this.state.modalVisible}
                footer={null}
                onCancel={this.onModalClose}
                centered={true}
            >
                <img style={{ height: "80vh", cursor: "zoom-out"}}
                    src={this.state.modalImage}
                    onClick={this.onModalClose}
                    alt=""
                />
            </Modal>

        </React.Fragment>
    );
    }

}

export default Master;
